export default {
	jobForms: {
		stepsAndTasksEdit: "Editing package steps and tasks",
		app: "Application",
		template: "Template",
		block: "Block",
		tasks: "Tasks",
		base: "base",
		allBases: "all bases",
		quanity: "quantity",
		cancel: "Cancel",
		pathError: "Error in the task path",
		noBaseSelectedForTask: "No base is selected for one of the tasks",
		problemWithAppSelect: "Problem with application selection",
		tryToDeleteStepAndRecreate: "Try deleting the step and re-creating it",
		incorrectlyEnteredData: "Incorrectly entered data",
		oneOfParamBaseNameNotdetermined: "One of the base short name parameters could not be determined",
		baseWillNotBeAutoSubstituted: "Base will not be automatically substituted",
		baseNameNoShortName: "Wrong selected base, select another and reverse your selection back"
	},
	packets: {
		createAppsPacket: "Create a package for applications",
		startOfPackageName: "Beginning of package (-s) name",
		apps: "Applications",
		byt: "individual",
		prom: "industrial",
		clean: "clean",
		withoutBindingToBases: "Without binding to bases",
		packageForEveryBase: "A package for each base",
		packageTemplate: "Template for a package",
		firstPackageStartTime: "Start time of the first package",
		othersPackagesInterval: "Other Packages Interval",
		cancel: "Cancel",
		massPackageDelete: "Multiple package deletion",
		showPackagesByTemplate: "Show packages based on template",
		packagesByThisTemplate: "Packages based on this template",
		selectAll: "select all",
		selected: "Selected",
		add: "Add",
		addPackage: "Add Package",
		createSomePackages: "Create multiple packages",
		edit: "Edit",
		editPackageName: "Edit Package Name",
		editPackageStepsAndTasks: "Edit Package Steps and Tasks",
		addPackageSchedule: "Add package schedule",
		editPackageSchedule: "Edit Package Schedule",
		delete: "Delete",
		deletePackageSchedule: "Delete package schedule",
		deletePackage: "Delete package",
		deletePackageByTemplate: "Delete packages by template",
		packageSort: "Sort packages",
		name: "Name",
		startTime: "Start time",
		templateEdited: "template changed",
		schedule: "Schedule",
		steps: "Steps",
		enterPackageName: "Enter package name",
		selectApps: "Select one or more applications",
		selectPackageCreateMode: "Select package creation mode",
		selectPackageTemplate: "Select a template for the package",
		enterStartTimeOfFirstPackage: "Enter the start time of the first package",
		enterPackageStartInterval: "Enter packet start interval",
		thisActionDeleteScheduleOfPackage: "This action will delete the schedule for this package",
		continue: "Continue",
		attention: "Attention",
		cancellation: "Cancel",
		accept: "Confirm",
		packageWereCreatedWithoutBases: "Packages were created without entered bases",
		fillBasesForEachPackage: "Fill in the bases for each package",
		notAllRequiredFieldsSelected: "Not all required fields are selected",
		noTemplateSelected: "No templates selected",
		thisActionDeleteThisPackage: "This action will remove this package",
		enterNewPackageName: "Enter new package name"
	},
	scheduleForm: {
		packageSchedule: "Package Schedule",
		daily: "Daily",
		weekly: "Weekly",
		dayOfWeek: "Day of the week",
		monthly: "Monthly",
		day: "Day",
		once: "One-time",
		special: "Special",
		blockSchedule: "Block Schedule",
		cancel: "Cancel",
		monday: "Monday",
		tuesday: "Tuesday",
		wednesday: "Wednesday",
		thursday: "Thursday",
		friday: "Friday",
		saturday: "Saturday",
		sunday: "Sunday",
		timeNotSelected: "No time selected",
		dateNotSelected: "No date selected",
		dayOfWeekNotSelected: "No day of the week selected",
		specialExpressionNotSelected: "Special expression not entered",
		incorrectFormat: "Schedule of the packet '{name}' has errors: '{schedule}', delete the schedule and create it again"
	},

	templateForm: {
		enterTemplateName: "Fill in the template name",
		templateName: "Template name",
		templateCreate: "Template creation",
		cancel: "Cancel"
	},
	templates: {
		selected: "Selected",
		addTemplate: "Add",
		copyTemplate: "Copy",
		editTemplateName: "Edit template tame",
		editTemplateTasks: "Edit template tasks",
		activateSchedule: "Activate schedule",
		forbidSchedule: "Forbid schedule",
		deleteTemplate: "Delete",
		packageWithPreviousVersion: "there is a package with a previous version",
		enterTemplateNewName: "Enter a new template name",
		enterCopyTemplateNewName: "Enter a copy template name of",
		accept: "Confirm",
		cancellation: "Cancel",
		thisActionDeleteThisTemplate: "This action will delete this template",
		continue: "Continue",
		attention: "Attention",
		noTemplateFound: "No template found"
	},
	templateTaskForm: {
		taskParams: "Task parameters",
		editTemplateTasks: "Editing Template Tasks",
		enterParams: "Fill in parameters",
		cancel: "Cancel",
		taskNotSelected: "No task selected",
		youNeedEnterTaskParams: "You need to fill in task parameters"
	}
}